module.exports = __webpack_public_path__ + "./static/img/userLove.ca7b3bc52de277e1a930ca0577bdeb81.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/welcome/userLove.png
// module id = ./client/src/assets/img/welcome/userLove.png
// module chunks = 0